import React from 'react';
import MathJax from "react-mathjax4";
import useStyles from "examsbook-react-sdk/custom-hooks/useStyles";
import useUserLanguage from "examsbook-react-sdk/custom-hooks/useUserLanguage";
/**
 * ExplanationSection of a question.
 * @param props
 * @returns {*}
 * @constructor
 */
function ExplanationSection(props) {
    const { viewMode, explanation,localesExplanation } = props;
    const { language } = useUserLanguage();
    const classes = useStyles(styles)();
    return (
        <React.Fragment>
            {(language === 'hn')? <>{
                viewMode && explanation !== '<p>undefined</p>' && explanation !== 'undefined' ?
                    <div className={classes.descbox}>
                        <div>
                            <MathJax.Context input="tex">
                                <MathJax.Html html={localesExplanation}/>
                            </MathJax.Context>
                        </div>
                    </div> : ''
            }</> :null}
             {(language === 'en')? <>{
                viewMode && explanation !== '<p>undefined</p>' && explanation !== 'undefined' ?
                    <div className={classes.descbox}>
                        <div>
                            <MathJax.Context input="tex">
                                <MathJax.Html html={explanation}/>
                            </MathJax.Context>
                        </div>
                    </div> : ''
            }</> :null}
            
        </React.Fragment>
    );
}

const styles = theme => ({
    descbox: {
        width: '100%',
        display: "inline-block",
        padding: '0 15px',
        boxSizing: 'border-box'
    }
});

export default ExplanationSection;
